export const companyInfo = {
  brandName: "Zenvoy Tours",
  legalName: '"ZENVOY TOURS" XK',
  legalType: "Xususiy korxona",
  stir: "312 974 300",
  registrationNumber: "3199215",
  registrationDate: "17.04.2026",
  region: "Samarqand viloyati, Kattaqo‘rg‘on tumani",
  address:
    "Yangiqo‘rg‘oncha MFY, Yangiqo‘rg‘oncha qishlog‘i, 656-uy",
  fullAddress:
    "Samarqand viloyati, Kattaqo‘rg‘on tumani, Yangiqo‘rg‘oncha MFY, Yangiqo‘rg‘oncha qishlog‘i, 656-uy",
  phone: "+998 20 027 34 84",
  phoneHref: "tel:+998200273484",
  email: "Jonibekumrzoqov59@gmail.com",
  website: "https://www.zenvoytours.uz",
  websiteLabel: "www.zenvoytours.uz",
  publicOfferPath: "/public.docx",
};
